<script setup>
import AppWell from '../../../../../Shared/AppWell.vue';
import AppCard from '../../../../../Shared/AppCard.vue';
import StudentsProfileStackFiltered from '../../../../../components/StudentsProfileStackFiltered.vue';
import { computed, ref } from 'vue';
import deburr from 'lodash/deburr';
import FormInput from '../../../../../components/Forms/FormInput.vue';
import FormLabel from '../../../../../components/Forms/FormLabel.vue';
import SurveyAnswerCommentsButton from './SurveyAnswerCommentsButton.vue';

const props = defineProps({
    report: {
        type: Object,
        required: true,
    },
    students: {
        type: Array,
        required: true,
    },
});

const showUnanswered = ref(false);
const search = ref('');

const answers = computed(() => {
    const searchValue = deburr(search.value.toLowerCase().trim());
    return props.report.answers
        .filter((a) => {
            if (showUnanswered.value) {
                return true;
            }
            return !a.not_answered;
        })
        .filter((a) => {
            if (searchValue === '') {
                return true;
            }

            if (a.text === null) {
                return false;
            }
            return deburr(a.text.toLowerCase()).includes(searchValue);
        });
});

const unansweredCount = computed(() => {
    return props.report.answers.filter((a) => {
        return a.not_answered;
    }).length;
});
</script>

<template>
    <div class="flex gap-4 items-center" v-if="answers.length > 1">
        <label>
            <input
                type="checkbox"
                :name="`showUnanswered_`"
                v-model="showUnanswered"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
            />
            <span class="ml-1"> {{ $t('messages.show_unanswered') }} ({{ unansweredCount }})</span>
        </label>
        <div>
            <FormLabel :value="$t('messages.filter_answers')" />
            <FormInput v-model="search" :placeholder="$t('messages.filter')" />
        </div>
    </div>

    <AppWell class="mt-3">
        <div class="grid grid-cols-4 gap-4" v-auto-animate>
            <div v-for="answer in answers" :key="answer.id">
                <AppCard>
                    <div class="flex justify-between gap-2">
                        <div class="shrink-0">
                            <StudentsProfileStackFiltered
                                :students="students"
                                :selected="[answer.user_id]"
                                class="inline-block h-8"
                                key-property="value"
                                name-property="text"
                            />
                        </div>
                        <div class="grow">
                            <div v-if="answer.not_answered" class="text-gray-500">
                                {{ $t('messages.unanswered') }}
                            </div>
                            <div v-else>{{ answer.text }}</div>
                            <div class="text-gray-600 mt-1 text-xs flex justify-end" v-if="answer.date">
                                {{ answer.date_display }}
                            </div>
                        </div>
                        <div class="shrink-0">
                            <SurveyAnswerCommentsButton :comments="answer.comments" v-if="answer.comments !== null" />
                        </div>
                    </div>
                </AppCard>
            </div>
        </div>
    </AppWell>
</template>
